package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2026_02_14_Day_1() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes have returned to their bastion in the afternoon. They have dinner plans with Lord Fox in the evening and plan to set sail north to Kostigan tomorrow at noon.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Annette investigates the north wall. A path clearly leads to the wall, but there is no guard tower, gate, or building nearby. On closer inspection, there was previously a gate in the wall which has been bricked over. On the other side of the wall is a green space and further in the distance, some homes.  Annette thinks the entrance ")
        org.jetbrains.compose.web.dom.Em {
            org.jetbrains.compose.web.dom.Text("could")
        }
        org.jetbrains.compose.web.dom.Text(" be restored.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Korvis goes into the woods on the west side of the bastion to make a druid den.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Caper visits the pond in the southwest. The man-made pond is 15 feet deep in the middle but includes significant shallow areas around the outside. In the past, it was well kept and stocked with ornamental fish, but it suffers from years without upkeep.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Falorn investigates the library on the 1st floor. There are many historical books, such as the history of the Dorvidian Empire 1000 years ago.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Annette explores a tower along the southern wall. The path on top of the wall is six feet wide. The wall construction appears solid enough that it could support mounted siege weapons.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Bigglesworth investigates the Ladies’ Chambers. He sniffs the air, nods confidently, and announces, “Room is… very room.”")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("At 6:30 p.m., the heroes meet up with Korvis to Wind Walk to Lord Fox’s estate. Arthur leads the heroes to the banquet room. Lord Fox’s servants have prepared a generous feast for the heroes. Lord Fox’s housekeeper, Viktor, has concluded his search for a groundskeeper. He introduces Stadler Fayless, who was previously employed at the heroes’ bastion 30 years ago when he was a young man. Now he is 55 years old with short grey hair. The heroes agree to hire him at his rate of 1 gold and 5 silver per day.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Korvis recasts Wind Walk, and the heroes return to the bastion. Caper, Tuesday, and Korvis sleep in the woods. Bigglesworth curls up in a crib in the nursery. The other heroes sleep in normal-sized beds on the 4th floor. During the night, Tuesday hears the flapping of wings from a large creature flying above (maybe a dragon).")
    }
}
